






















import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import RadioList from '@/components/RadioList.vue'
import NavigationFooter from '@/components/NavigationFooter.vue'
import TrackingMixin from '@/mixins/TrackingMixin.vue'
import { IListItem } from '@/store/interface/IListItem'
import cancelledOptions from '@/store/data/cancelledOptions'

/**
 * CancelledBy Page
 *
 * Defines whether the case is eligible or not, and routes customer to the
 * appropriate page, depending on his choice
 */
@Component({
	name: 'CancelledByPage',
	components: {
		PageHeader,
		RadioList,
		NavigationFooter
	},
	mixins: [TrackingMixin]
})
export default class CancelledByPage extends Vue {
	private isPageValid: boolean = false
	private selectedOption: string = ''
	private cancelledList: IListItem[] = cancelledOptions

	private onCancelledOptionClick (val: IListItem): void {
		this.selectedOption = `${val.id}`
		this.isPageValid = true
	}

	private onPageSubmit (): void {
		this.$router.push(this.selectedOption)
	}
}
